import { render, staticRenderFns } from "./PrintTermsFeeSchedule.vue?vue&type=template&id=27a8001c"
import script from "./PrintTermsFeeSchedule.vue?vue&type=script&lang=ts"
export * from "./PrintTermsFeeSchedule.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports